import { findIn } from '../../app/helpers/entity'

/**
 * AddMultiSetCtrl controller
 */

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')
AddMultiSetCtrl.mixes = [
  'openPopupCtrlMixin'
]

// /**
//  * @param $uibModal
//  * @param {models.LiveEventSet} cs
//  * @param item
//  * @param {(function(boolean=): Promise<unknown>)|(function(): void)|*} checkIntersection
//  * @param windowClass
//  */
// export const openCSModal = function ($uibModal, cs, item, checkIntersection, windowClass = 'modal-class-conflict') {
//   item.openConflict = true
//
//   $uibModal.open({
//     templateUrl: 'components/packages/popups/contentSetsModal.html',
//     controller: 'ContentSetsModalCtrl as vm',
//     windowClass: 'modal-class-conflict',
//     backdrop: true,
//     animation: false,
//     resolve: {
//       cs: function () {
//         return cs
//       },
//       item: function () {
//         return item
//       },
//       checkIntersection: function () {
//         return checkIntersection
//       }
//     }
//   })
//     .result
//     .then(
//       function close () {
//       },
//       function dismiss () {
//         item.openConflict = false
//       })
// }
//
// /**
//  * Checking Content Set on intersection
//  *
//  * @param $http
//  * @param alertLiteSvc
//  * @param cs
//  * @param assigned
//  * @param isNew
//  * @returns {*|Promise<unknown>}
//  */
// export const checkCSIntersection = function ($http, alertLiteSvc, cs, assigned, isNew) {
//   if (!assigned.length || isNew) { return Promise.resolve(false) }
//
//   const url = cs.$_contentIntersectionUrlTemplate(cs)
//   const params = { ids: assigned.map(({ id }) => id) }
//   if (cs.$setType === 'tv_show') {
//     params.itemType = cs.itemType
//   }
//   const conflictsByItemId = {}
//
//   return $http.get(url, { params })
//     .data()
//     .then((resp) => resp.payload)
//     .then((data) => {
//       data.forEach(item => {
//         if (!conflictsByItemId[item.contentId]) { conflictsByItemId[item.contentId] = {} }
//         conflictsByItemId[item.contentId][item.contentSetId] = {
//           name: item.contentSetName,
//           subscriptions: [item, ...(conflictsByItemId[item.contentId][item.contentSetId]?.subscriptions || [])]
//         }
//       })
//     })
//     .then(() => {
//       assigned.forEach(item => {
//         item.conflicts = conflictsByItemId[item.id]
//         item.conflictsQuantity = !!conflictsByItemId[item.id] && Object.keys(conflictsByItemId[item.id]).length
//       })
//       return !!Object.keys(conflictsByItemId).length
//     })
//     .catch(rejection => alertLiteSvc.alertError(rejection?.statusText))
// }
//
// /**
//  *
//  * @param $uibModal
//  * @param cs
//  * @param {*} assignedSubscriptions
//  * @param {*} assignedItems
//  * @param {*[]} cachedItemsIds
//  */
// export const newItemPriceError = function ($uibModal, cs, assignedSubscriptions, assignedItems, cachedItemsIds) {
//   const initialSubs = []
//   let displayedSubscriptions = []
//   let newItems = []
//   angular.copy(assignedSubscriptions, initialSubs)
//   if (cs.pricing.currency) {
//     displayedSubscriptions = assignedSubscriptions.filter(sub => {
//       const correctedRent = !sub.perItemRentPriceRequired || (sub.rent && sub.rent.amount)
//       const correctedBuy = !sub.perItemBuyPriceRequired || (sub.buy && sub.buy.amount)
//       if (correctedRent && correctedBuy) {
//         return false
//       }
//       const correctCurrency = sub.currency.id === cs.pricing.currency.id
//       const correctRent = !sub.perItemRentPriceRequired || (cs.$rentEnabled && cs.pricing.rent && cs.pricing.rent.paymentMethod === 'PER_ITEM') || (sub.rent && sub.rent.amount)
//       const correctBuy = !sub.perItemBuyPriceRequired || (cs.$buyEnabled && cs.pricing.buy && cs.pricing.buy.paymentMethod === 'PER_ITEM') || (sub.buy && sub.buy.amount)
//       return !(correctCurrency && correctRent && correctBuy)
//     })
//     newItems = assignedItems.filter(item => !cachedItemsIds.includes(item.id))
//   }
//   if (displayedSubscriptions.length > 0 && newItems.length > 0) {
//     return $uibModal.open({
//       templateUrl: 'components/packages/views/newItemsPrice.html',
//       controller: 'NewItemsPriceCtrl as vm',
//       animation: false,
//       size: 'lg',
//       resolve: {
//         subscriptions: function () {
//           return displayedSubscriptions
//         },
//         cs: function () {
//           return cs
//         }
//       }
//     }).result
//       .then(
//         function close (correctedSubscriptions) {
//           assignedSubscriptions.forEach(subscription => {
//             const correctedSubscription = correctedSubscriptions.find(sub => sub.id === subscription.id)
//             if (correctedSubscription) {
//               subscription = { ...correctedSubscription }
//             }
//           })
//         },
//         function dismiss () {
//           angular.copy(initialSubs, assignedSubscriptions) // restore pricing
//           return Promise.reject('dismiss')
//         })
//   }
//   return Promise.resolve()
// }
/**
 * AddMultiSetCtrl controller
 *
 * @class AddMultiSetCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:openPopupCtrlMixin*
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddMultiSetCtrl
 */
/* @ngInject */
export default function AddMultiSetCtrl ($http, $scope, $location, $uibModal, MultiSet, NetworkCurrency, alertLiteSvc, ms, pckg) {
  var vm = this

  /**
   * Channel Set
   *
   * @memberof mwApp/packages.controller:AddMultiSetCtrl
   * @type {models.ChannelSet}
   */

  vm.ms = ms

  /**
   * Network
   *
   * @memberof mwApp/packages.controller:AddMultiSetCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg
  const networkId = vm.pckg.id

  vm.ngQuillToolbar = {
    toolbar: [
      ['bold', 'underline', 'strike'], // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: ['', 'center', 'right'] }],
      ['image']
    ]
  }

  /**
   * Currencies list
   *
   * @memberof mwApp/settings.controller:PaymentSystemCtrl
   * @name vm.currencies
   * @type {models.NetworkCurrency[]}
   */

  // load currencies
  NetworkCurrency.loadAll({ network: pckg })
    .then(data => data.filter(c => c.enabled))
    .to(vm.currencies = [])
    .then(() => {
      vm.ms.pricing.currency = vm.ms.pricing.currency
        ? findIn(vm.currencies)(vm.ms.pricing.currency)
        : vm.currencies[0]
    })
    .finally(() => { vm.extraLoaded = true })

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddMultiSetCtrl
   * @type {Boolean}
   */
  vm.isNew = ms._isNew()

  /**
   * Table state
   *
   * @memberof mwApp/packages.controller:AddMultiSetCtrl
   * @type {Object[]}
   */
  vm.defaultPagination = {
    q: '',
    page: 0,
    last: false,
    count: 25
  }

  /**
   * get available channels
   *
   * @memberof mwApp/packages.controller:AddMultiSetCtrl
   * @type {Object[]}
   */
  vm.getAllSets = function () {
    const promises = [
      ms._getAvailableItems(networkId, 'vod-sets', vm.defaultPagination),
      ms._getAvailableItems(networkId, 'tv-show-sets', vm.defaultPagination),
      ms._getAvailableItems(networkId, 'live-event-sets', vm.defaultPagination),
      ms._getAvailableItems(networkId, 'channel-sets', vm.defaultPagination)
    ]
    Promise.all(promises).then(res => {
      vm.disableVodSets = !res[0].content.length
      vm.disableTvShowSets = !res[1].content.length
      vm.disableLiveEventSets = !res[2].content.length
      vm.disableChannelSets = !res[3].content.length
    })
  }
  vm.getAllSets()

  vm.addSets = function (type) {
    $uibModal.open({
      templateUrl: 'components/packages/views/addMultiSetItems.html',
      controller: 'AddMultiSetItemsCtrl as vm',
      animation: false,
      size: 'xl',
      resolve: {
        assignedItems: function () {
          return vm.ms[type + 'Sets']
        },
        type: function () {
          return type
        },
        ms: function () {
          return vm.ms
        }
      }
    }).result
      .then(
        function close (items) {
          vm.ms[type + 'Sets'] = angular.copy(items)
          $scope.form.$setDirty()
        },
        function dismiss () {
        })
  }

  vm.saveSet = function () {
    if (vm.atLeastOneSet() || vm.toMuchSets()) {
      return
    }
    vm.setDisable()
    ms._save()
      .then((res) => {
        ms._update().then(() => {
          if (vm.isNew) {
            $location.url(ms._publicListUrl + res.data.payload.id)
          }
        })
      })
      .then(vm.location(ms).reload)
      .finally(vm.unsetDisable)
  }

  vm.deleteSet = function (setType, set) {
    $scope.form.$setDirty()
    vm.ms[setType] = vm.ms[setType].filter(s => s.id !== set.id)
  }

  vm.clearSets = function (setType) {
    $scope.form.$setDirty()
    vm.ms[setType] = []
  }

  /**
   * Upload logo
   *
   * @memberof mwApp/packages.controller:AddMultiSetCtrl
   * @function
   */
  function uploadLogo (file, type) {
    return ms._uploadFile(null, file, { type }).data()
  }

  vm.uploadIcon = (file) => {
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (this.width * this.height > 16800000) {
        alertLiteSvc.alertError('Max resolution of image is 16.8MPx')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, 'cover_multi_set')
        .then((url) => {
          vm.ms.coverImageUrl = url
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
    $scope.form.$setDirty()
  }

  vm.atLeastOneSet = function () {
    return !(vm.ms.vodSets.length || vm.ms.channelSets.length || vm.ms.tvShowSets.length || vm.ms.liveEventSets.length)
  }
  vm.toMuchSets = function () {
    return vm.ms.vodSets.length + vm.ms.channelSets.length + vm.ms.tvShowSets.length + vm.ms.liveEventSets.length > 100
  }

  vm.showAllButton = function (id) {
    const realContainer = document.getElementById('inner-' + id)
    return realContainer.clientHeight > 240
  }

  vm.showAllButtonLabel = function (id) {
    const container = document.getElementById(id)
    return container.clientHeight === 240 ? 'Show All' : 'Hide'
  }

  vm.showAll = function (id) {
    const container = document.getElementById(id)
    if (container.clientHeight === 240) {
      container.style.maxHeight = 'unset'
    } else {
      container.style.maxHeight = '240px'
    }
  }

  /**
   * Create or edit coupon, and close modal window afterwards
   *
   * @memberof mwApp/packages.controller:AddMultiSetCtrl
   */
  vm.submit = function () {
    vm.saveSet()
  }

  vm.delete = function () {
    vm.ms._delete().then(() => vm.back())
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/packages.controller:AddMultiSetCtrl
   */
  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(vm.pckg._publicUrl + '/contentSets#multi_sets')
    }
  }
}
